var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "info 1",
    clipPath: "url(#clip0_878_21951)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M13.6034 16.9094C13.358 16.9323 13.1117 16.8769 12.8997 16.7512C12.7449 16.5922 12.6706 16.3715 12.6979 16.1512C12.7037 15.9679 12.7256 15.7853 12.7634 15.6058C12.8 15.3998 12.8473 15.1959 12.9052 14.9949L13.5488 12.7803C13.6152 12.5617 13.6591 12.3369 13.6797 12.1094C13.6797 11.8639 13.7125 11.6948 13.7125 11.5967C13.7261 11.1592 13.5394 10.7394 13.2052 10.4567C12.7941 10.1411 12.2823 9.986 11.7652 10.0203C11.3946 10.0259 11.0269 10.0865 10.6743 10.2003C10.2888 10.3203 9.88334 10.4639 9.4579 10.6312L9.27246 11.3512C9.3979 11.3076 9.55066 11.2585 9.72518 11.2039C9.89168 11.1546 10.0643 11.1289 10.2379 11.1276C10.4815 11.1012 10.7266 11.161 10.9306 11.2967C11.0692 11.462 11.1342 11.6768 11.1106 11.8912C11.11 12.0747 11.0899 12.2575 11.0506 12.4367C11.0124 12.6276 10.9633 12.8294 10.9033 13.0421L10.2543 15.2675C10.2019 15.4744 10.1601 15.6837 10.1288 15.8948C10.1033 16.0755 10.0906 16.2578 10.0906 16.4403C10.0879 16.8807 10.2894 17.2977 10.6361 17.5693C11.0534 17.8898 11.5726 18.0487 12.0979 18.0166C12.4677 18.0242 12.8363 17.9708 13.1888 17.8584C13.4979 17.7529 13.9106 17.6021 14.427 17.4057L14.6015 16.7184C14.4617 16.7764 14.3176 16.8238 14.1706 16.8602C13.9847 16.9027 13.7938 16.9192 13.6034 16.9094Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M14.2855 6.40958C13.9887 6.13695 13.5976 5.99028 13.1946 6.0005C12.7919 5.99141 12.4012 6.13794 12.1037 6.40958C11.5585 6.87973 11.4976 7.70291 11.9678 8.2482C12.0097 8.29681 12.0551 8.34223 12.1037 8.38414C12.7249 8.93975 13.6644 8.93975 14.2855 8.38414C14.8307 7.90934 14.8879 7.08247 14.4131 6.53722C14.3736 6.4918 14.331 6.44914 14.2855 6.40958Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0ZM12 22.9091C5.97506 22.9091 1.09092 18.0249 1.09092 12C1.09092 5.97506 5.97506 1.09092 12 1.09092C18.0249 1.09092 22.9091 5.97506 22.9091 12C22.9091 18.0249 18.0249 22.9091 12 22.9091Z",
    fill: "black"
  })))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_878_21951"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.2d7a6b755bfd29206415c46417307f7d.svg";
export { ForwardRef as ReactComponent };